import { lazy } from "react";
import { enumPermisosTrx } from "./enumPermisosTrx";
import ParametrosZonas from "./Views/Comercios/ParametrosZonas";

/** Componente de iconos */
const AppIcons = lazy(() => import("../../components/Base/AppIcons"));

/**
 * Trx params
 */
const CreatePlanComision = lazy(() =>
  import("./Views/Comisiones/CreatePlanComision")
);
const MainPlanComisiones = lazy(() =>
  import("./Views/Comisiones/MainPlanComisiones")
);
const MainAsignaciones = lazy(() =>
  import("./Views/Comisiones/MainAsignaciones")
);
const CreateAssigns = lazy(() => import("./Views/Comisiones/CreateAssigns"));
const MainPlanComisionesCampana = lazy(() =>
  import("./Views/Comisiones/MainPlanComisionesCampana")
);
const CreatePlanComisionCampana = lazy(() =>
  import("./Views/Comisiones/CreatePlanComisionCampana")
);

const ParametrosAutorizadores = lazy(() =>
  import("./Views/ParametrosAutorizadores")
);
const ParametrosCategorizacion = lazy(() =>
  import("./Views/ParametrosCategorizacion")
);
const AsignacionCategorias = lazy(() => import("./Views/AsignacionCategorias"));
const TipoContratoComisiones = lazy(() =>
  import("./Views/TipoContratoComisiones")
);
const Comisiones = lazy(() => import("./Views/Comisiones"));
const Com2Pay = lazy(() => import("./Views/Comisiones/Com2Pay"));
const CreateComision = lazy(() => import("./Views/Comisiones/CreateComision"));
const GruposPlanesComisiones = lazy(() =>
  import("./Views/Comisiones/GruposPlanes/GruposPlanesComisiones")
);
const Com2Collect = lazy(() => import("./Views/Comisiones/Com2Collect"));
const Convenios = lazy(() => import("./Views/Convenios/Convenios"));
const ConveniosPDP = lazy(() => import("./Views/ConveniosPDP"));
const AdminConveniosPDP = lazy(() => import("./Views/ConveniosPDP/Admin"));
const ConveniosAutorizadoresRecaudo = lazy(() =>
  import("./Views/ConveniosPDP/AutorizadoresRecaudo")
);
const ConvAuto = lazy(() => import("./Views/ConvAuto"));
const Autorizadores = lazy(() => import("./Views/Autorizadores"));
const ReporteConfiguracionComisiones = lazy(() =>
  import("./Views/Comisiones/ReporteConfiguracionComisiones")
);

const CreateComisionCobrada = lazy(() =>
  import("./Views/Comisiones/CreateComisionCobrada")
);
const ConfiguracionComercios = lazy(() =>
  import("./Views/ConfiguracionComercios")
);
const CrearComercios = lazy(() => import("./Views/Comercios/CrearComercios"));
const ListarComercios = lazy(() => import("./Views/Comercios/ListarComercios"));
const GestionPermisosBroker = lazy(() =>
  import("./Views/Comercios/GestionPermisosBroker")
);
const ComerciosBroker = lazy(() => import("./Views/Comercios/ComerciosBroker"));
const TipoNivelComercio = lazy(() => import("./Views/TipoNivelComercios"));
const ListarMensajePublicitario = lazy(() =>
  import("./Views/MensajesPublicitarios/ListarMensajePublicitario")
);
const GruposComercios = lazy(() =>
  import("./Views/Comercios/GruposComercios/GruposComercios")
);
const EditGruposComercios = lazy(() =>
  import("./Views/Comercios/GruposComercios/EditGruposComercios")
);
const GruposConvenios = lazy(() =>
  import("./Views/Convenios/GruposConvenios/GruposConvenios")
);
const EditGruposConvenios = lazy(() =>
  import("./Views/Convenios/GruposConvenios/EditGruposConvenios")
);
const EditGruposPlanesComisiones = lazy(() =>
  import("./Views/Comisiones/GruposPlanes/EditGruposPlanesComisiones")
);
const navConvenios = lazy(() => import("./Views/Convenios/navConvenios"));
const Comercios = lazy(() => import("./Views/Comercios"));
const HistoricoCreacionMasivaComercio = lazy(() => import("./Views/Comercios/HistoricoCreacionMasivaComercio"));
/**
 * Editar parametros tipos de transacciones
 */
const ParamsOperations = lazy(() =>
  import("../ParamsOperations/ParamsOperations")
);
const TypesTrxs = lazy(() => import("../ParamsOperations/Views/TypesTrxs"));
const ParametrizacionCodBarrasConvenio = lazy(() =>
  import("./Views/ParametrizacionCodBarrasConvenio")
);

const listPermissions = Object.values(enumPermisosTrx);
export const listPermissionsTrx = listPermissions.splice(
  listPermissions.length / 2
);

const DistribucionTransacciones = lazy(() =>
  import("./Views/DistribucionTransacciones"));

const RecaudoGenericoConvenios = lazy(() =>
  import("./Views/RecaudoGenericoConvenios"));

const CrearConvenioGenerico = lazy(() =>
  import("./Views/RecaudoGenericoConvenios/CrearConvenioGenerico"));

const ActualizarConvenioGenerico = lazy(() =>
  import("./Views/RecaudoGenericoConvenios/ActualizarConvenioGenerico"));

const CategoriaRecaudoGenerico = lazy(() =>
  import("./Views/CategoriaRecaudoGenerico"));

const BlockAgreements = lazy(() =>
  import("./Views/BloquearComveniosParaTodos/BloqueosConvenios"));

const TerminalesModulo = lazy(() =>
  import("./Views/Terminales/ModuloTerminales"));
const TerminalesCreacion = lazy(() =>
  import("./Views/Terminales/CreacionTerminales"));
const TerminalesHistorico = lazy(() =>
  import("./Views/Terminales/HistoricoTerminales"));

const rutasConfiguraciones = {
  link: "/params-operations",
  label: (
    <AppIcons
      Logo={"PARAMETROS_TRANSACCIONALES"}
      name={"Parametros transaccionales"}
    />
  ),
  component: ParamsOperations,
  permission: listPermissionsTrx,
  subRoutes: [
    {
      link: "/params-operations/parametros-categorizacion",
      label: <AppIcons Logo={"RECAUDO"} name={"Parámetros categorización"} />,
      component: ParametrosCategorizacion,
      permission: [enumPermisosTrx.categorizacion],
    },
    {
      link: "/params-operations/asignacion-categorias",
      label: <AppIcons Logo={"RECAUDO"} name={"Asignación Categorías"} />,
      component: AsignacionCategorias,
      permission: [enumPermisosTrx.categorizacion],
    },
    {
      link: "/params-operations/parametros-autorizadores",
      label: <AppIcons Logo={"RECAUDO"} name={"Parametros por autorizador"} />,
      component: ParametrosAutorizadores,
      permission: [enumPermisosTrx.parametros_autorizadores],
    },
    {
      link: "/params-operations/types-trxs",
      label: <AppIcons Logo={"RECAUDO"} name={"Tipos de transacciones"} />,
      component: TypesTrxs,
      permission: [enumPermisosTrx.tipos_transacciones],
    },
    {
      link: "/params-operations/comisiones",
      label: <AppIcons Logo={"IMPUESTO"} name={"Tarifas / Comisiones"} />,
      component: Comisiones,
      permission: [
        enumPermisosTrx.planes_comision,
        enumPermisosTrx.asignacion_comision,
      ],
      subRoutes: [
        // {
        //   link: "/params-operations/comisiones/pagadas",
        //   label: <AppIcons Logo={"IMPUESTO"} name={"Comisiones a pagar"} />,
        //   component: Com2Pay,
        //   permission: [enumPermisosTrx.planes_comision],
        //   subRoutes: [
        //     {
        //       link: "/params-operations/comisiones/pagadas/personalizadas",
        //       label: (
        //         <AppIcons
        //           Logo={"IMPUESTO"}
        //           name={"Comisiones a pagar por comercio"}
        //         />
        //       ),
        //       component: CreateComision,
        //       permission: [enumPermisosTrx.planes_comision],
        //     },
        //   ],
        // },
        // {
        //   link: "/params-operations/comisiones/cobradas",
        //   label: <AppIcons Logo={"IMPUESTO"} name={"Comisiones a cobrar"} />,
        //   component: Com2Collect,
        //   permission: [enumPermisosTrx.asignacion_comision],
        //   subRoutes: [
        //     {
        //       link: "/params-operations/comisiones/cobradas/crear",
        //       label: (
        //         <AppIcons
        //           Logo={"IMPUESTO"}
        //           name={"Comisiones a cobrar por autorizador"}
        //         />
        //       ),
        //       component: CreateComisionCobrada,
        //       permission: [enumPermisosTrx.asignacion_comision],
        //     },
        //   ],
        // },

        {
          link: "/params-operations/comisiones/asignaciones",
          label: (
            <AppIcons Logo={"IMPUESTO"} name={"Asignación de comisiones"} />
          ),
          component: MainAsignaciones,
          permission: [enumPermisosTrx.asignacion_comision],
          subRoutes: [
            {
              link: "/params-operations/comisiones/asignaciones/crear",
              label: (
                <AppIcons Logo={"IMPUESTO"} name={"Asignación de comisiones"} />
              ),
              component: CreateAssigns,
              permission: [enumPermisosTrx.asignacion_comision],
            },
            {
              link: "/params-operations/comisiones/asignaciones/edit/:id",
              label: (
                <AppIcons Logo={"RECAUDO"} name={"Asignación de comisiones"} />
              ),
              component: CreateAssigns,
              permission: [enumPermisosTrx.asignacion_comision],
              show: false,
            },
          ],
        },
        {
          link: "/params-operations/comisiones/plan-comisiones",
          label: <AppIcons Logo={"IMPUESTO"} name={"Plan de comisiones"} />,
          component: MainPlanComisiones,
          permission: [enumPermisosTrx.planes_comision],
          subRoutes: [
            {
              link: "/params-operations/comisiones/plan-comisiones/crear",
              label: (
                <AppIcons Logo={"IMPUESTO"} name={"Crear plan de comisión"} />
              ),
              component: CreatePlanComision,
              permission: [enumPermisosTrx.planes_comision],
            },
          ],
        },
        {
          link: "/params-operations/comisiones/plan-comisiones-campana",
          label: (
            <AppIcons Logo={"IMPUESTO"} name={"Plan de comisiones campañas"} />
          ),
          component: MainPlanComisionesCampana,
          permission: [enumPermisosTrx.planes_comision],
          // subRoutes: [
          //   {
          //     link: "/params-operations/comisiones/plan-comisiones/campana/crear",
          //     label: (
          //       <AppIcons
          //         Logo={"IMPUESTO"}
          //         name={"Crear plan de comisión campaña"}
          //       />
          //     ),
          //     component: CreatePlanComisionCampana,
          //     permission: [19],
          //   },
          // ],
        },
        {
          link: "/params-operations/grupos-planes-comisiones",
          label: (
            <AppIcons
              Logo={"RECAUDO"}
              name={"Grupos de planes de comisiones"}
            />
          ),
          component: GruposPlanesComisiones,
          permission: [enumPermisosTrx.planes_comision],
        },
        {
          link: "/params-operations/grupos-planes-comisiones/edit/:id",
          label: (
            <AppIcons
              Logo={"RECAUDO"}
              name={"Grupos de planes de comisiones"}
            />
          ),
          component: EditGruposPlanesComisiones,
          permission: [enumPermisosTrx.planes_comision],
          show: false,
        },
        {
          link: "/params-operations/comisiones/reporte-configuracion-comisiones",
          label: (
            <AppIcons
              Logo={"IMPUESTO"}
              name={"Reporte configuración de comisiones"}
            />
          ),
          component: ReporteConfiguracionComisiones,
          permission: [enumPermisosTrx.asignacion_comision],
          subRoutes: [],
        },
      ],
    },
    {
      link: "/params-operations/convenios-recaudo",
      label: <AppIcons Logo={"RECAUDO"} name={"Convenios de recaudo"} />,
      component: ConveniosPDP,
      permission: [20],
      subRoutes: [
        {
          link: "/params-operations/convenios-recaudo/administrar",
          label: <AppIcons Logo={"RECAUDO"} name={"Administrar convenios"} />,
          component: AdminConveniosPDP,
          permission: [20],
        },
        {
          link: "/params-operations/convenios-recaudo/autorizadores-recaudo",
          label: (
            <AppIcons Logo={"RECAUDO"} name={"Autorizadores de recaudo"} />
          ),
          component: ConveniosAutorizadoresRecaudo,
          permission: [20],
        },
      ],
    },
    {
      link: "/params-operations/navconvenios",
      label: <AppIcons Logo={"RECAUDO"} name={"Convenios"} />,
      component: navConvenios,
      permission: [enumPermisosTrx.convenios, enumPermisosTrx.grupos_comercios],
      subRoutes: [
        {
          link: "/params-operations/convenios",
          label: <AppIcons Logo={"RECAUDO"} name={"Convenios"} />,
          component: Convenios,
          permission: [enumPermisosTrx.tipo_nivel_comercio],
        },
        {
          link: "/params-operations/grupos-convenios",
          label: <AppIcons Logo={"RECAUDO"} name={"Grupos de convenios"} />,
          component: GruposConvenios,
          permission: [enumPermisosTrx.convenios],
        },
        {
          link: "/params-operations/grupos-convenios/edit/:id",
          label: <AppIcons Logo={"RECAUDO"} name={"Grupos de convenios"} />,
          component: EditGruposConvenios,
          permission: [enumPermisosTrx.grupos_comercios],
          show: false,
        },
        {
          link: "/params-operations/convenios-recaudo/parametrizar-codigos-barras-convenios",
          label: (
            <AppIcons
              Logo={"RECAUDO"}
              name={"Parametrizar códigos de barras convenios"}
            />
          ),
          component: ParametrizacionCodBarrasConvenio,
          permission: [
            enumPermisosTrx.PARAMETRIZACION_CODIGOS_BARRAS_CONVENIOS,
          ],
        },
        {
          link: "/params-operations/convenios-recaudo/distribucion-transacciones",
          label: <AppIcons Logo={"RECAUDO"} name={"Distribución Transacciones Recaudo Genérico"} />,
          component: DistribucionTransacciones,
          permission: [enumPermisosTrx.DISTRIBUCION_TRANSACCIONES],
        },
        {
          link: "/params-operations/convenios-recaudo/convenios-recaudo-generico",
          label: <AppIcons Logo={"RECAUDO"} name={"Recaudo Genérico - Administrar Convenios"} />,
          component: RecaudoGenericoConvenios,
          permission: [enumPermisosTrx.RECAUDO_GENERICO_ADMINISTRAR_CONVENIOS],
          subRoutes: [
            {
              link: "/params-operations/convenios-recaudo/convenios-recaudo-generico/crear-convenio",
              label: <AppIcons Logo={"RECAUDO"} name={"Recaudo Genérico - Administrar Convenios"} />,
              component: CrearConvenioGenerico,
              permission: [enumPermisosTrx.DISTRIBUCION_TRANSACCIONES],
            },
            {
              link: "/params-operations/convenios-recaudo/convenios-recaudo-generico/actualizar-convenio",
              label: <AppIcons Logo={"RECAUDO"} name={"Recaudo Genérico - Administrar Convenios"} />,
              component: ActualizarConvenioGenerico,
              permission: [enumPermisosTrx.DISTRIBUCION_TRANSACCIONES],
            },
          ]
        },
        {
          link: "/params-operations/convenios-recaudo/categorias-recaudo-generico",
          label: <AppIcons Logo={"RECAUDO"} name={"Categorías Recaudo Genérico"} />,
          component: CategoriaRecaudoGenerico,
          permission: [enumPermisosTrx.CATEGORIA_RECAUDO_GENERICO],
        },
      ],
    },

    {
      link: "/params-operations/autorizadores",
      label: (
        <AppIcons
          Logo={"PRODUCTOS_FINANCIEROS"}
          name={"Proveedores / Autorizadores"}
        />
      ),
      component: Autorizadores,
      permission: [enumPermisosTrx.autorizadores],
    },
    {
      link: "/params-operations/configuracion_comercios",
      label: <AppIcons Logo={"RECAUDO"} name={"Configuración comercios"} />,
      component: ConfiguracionComercios,
      permission: [enumPermisosTrx.configuracion_comercios],
    },
    {
      link: "/params-operations/tipo_contrato_comisiones",
      label: <AppIcons Logo={"RECAUDO"} name={"Contratos comisiones"} />,
      component: TipoContratoComisiones,
      permission: [enumPermisosTrx.contratos_comisiones],
      subRoutes: [
        {
          link: "/params-operations/convenios/autorizadores",
          label: (
            <AppIcons Logo={"RECAUDO"} name={"Autorizadores de convenio"} />
          ),
          component: ConvAuto,
          permission: [enumPermisosTrx.contratos_comisiones],
        },
      ],
    },
    {
      link: "/params-operations/comercios",
      label: <AppIcons Logo={"RECAUDO"} name={"Comercios"} />,
      component: ListarComercios,
      permission: [enumPermisosTrx.comercios, enumPermisosTrx.gestion_comercios],
    },
    {
      link: "/params-operations/comercios/:pk_comercio",
      label: <AppIcons Logo={"RECAUDO"} name={"Comercios"} />,
      component: CrearComercios,
      permission: [enumPermisosTrx.comercios, enumPermisosTrx.gestion_comercios],
      show: false,
    },
    {
      link: "/params-operations/comercios-params",
      label: <AppIcons Logo={"RECAUDO"} name={"Parametrización comercios"} />,
      component: Comercios,
      permission: [enumPermisosTrx.comercios],
      subRoutes: [
        // {
        //   link: "/params-operations/tipo-nivel-comercios",
        //   label: <AppIcons Logo={"RECAUDO"} name={"Tipo nivel comercios"} />,
        //   component: TipoNivelComercio,
        //   permission: [enumPermisosTrx.tipo_nivel_comercio],
        // },
        
        {
          link: "/params-operations/comercios-params/gestion-permisos-broker",
          label: <AppIcons Logo={"RECAUDO"} name={"Gestión Permisos Broker"} />,
          component: GestionPermisosBroker,
          permission: [enumPermisosTrx.gestion_permisos_broker],
        },
        {
          link: "/params-operations/comercios-params/permisos-broker",
          label: (
            <AppIcons Logo={"RECAUDO"} name={"Permisos Comercios Broker"} />
          ),
          component: ComerciosBroker,
          permission: [enumPermisosTrx.gestion_permisos_comercios_broker],
        },
        {
          link: "/params-operations/comercios-params/grupos-comercio",
          label: <AppIcons Logo={"RECAUDO"} name={"Grupos de comercios"} />,
          component: GruposComercios,
          permission: [enumPermisosTrx.grupos_comercios],
        },
        {
          link: "/params-operations/comercios-params/grupos-comercio/edit/:id",
          label: <AppIcons Logo={"RECAUDO"} name={"Grupos de comercios"} />,
          component: EditGruposComercios,
          permission: [enumPermisosTrx.grupos_comercios],
          show: false,
        },
        {
          link: "/params-operations/comercios-params/gestion-zonas",
          label: <AppIcons Logo={"RECAUDO"} name={"Gestión zonas"} />,
          component: ParametrosZonas,
          permission: [enumPermisosTrx.comercios],
        },
        
      ],
    },
    {
      link: "/params-operations/comercios-params/historico-creacion-masiva",
      label: <AppIcons Logo={"RECAUDO"} name={"Histórico Creación Masiva Comercios"} />,
      component: HistoricoCreacionMasivaComercio,
      permission: [enumPermisosTrx.comercios, enumPermisosTrx.gestion_historico_comercios],
    },
    {
      link: "/params-operations/mensajes_publicitarios",
      label: <AppIcons Logo={"RECAUDO"} name={"Mensajes publicitarios"} />,
      component: ListarMensajePublicitario,
      permission: [enumPermisosTrx.mensajes_publicitarios],
    },    
    // Terminales
    {
      link: "/params-operations/terminales",
      label: <AppIcons Logo={"RECAUDO"} name={"Creaci\u00f3n Terminales"} />,
      component: TerminalesModulo,
      permission: [enumPermisosTrx.TERMINALES]
    },
    {
      link: "/params-operations/historico-terminales",
      label: <AppIcons Logo={"RECAUDO"} name={"Hist\u00f3rico Creaci\u00f3n Masiva Terminales"} />,
      component: TerminalesHistorico,
      permission: [enumPermisosTrx.HISTORICO_TERMINALES],
    },
  ],
};

export const rutasBloqueoComercioTodos = {
  link: "/GestionTransaccional/bloqueo-convenios-para-todos",
  label: <AppIcons Logo={"RECAUDO"} name="Bloqueo de Convenios" />,
  component: BlockAgreements,
  permission:  [enumPermisosTrx.BLOQUEAR_CONVENIO_TODOS],
  subRoutes: [],
};

export default rutasConfiguraciones;
